<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>

<script>
import { add, getStatus, getDetails, update, del } from "@/api/tracker/status";
import cTable from "@/base/common/index";
export default {
  name: "trackerStatus",
  components: {
    cTable
  },
  async mounted() {},
  methods: {},
  data() {
    let statusList = [
      { label: this.$t("YES"), value: "YES" },
      { label: this.$t("NO"), value: "NO" }
    ];
    return {
      methods: {
        list: getStatus,
        add,
        update,
        getDetails,
        del
      },
      modals: {
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              console.log(row);
              this.$page
                .handleRequestMethods(row.id ? "update" : "add", row, true)
                .then(e => {
                  this.$page.getList();
                  close();
                });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            modalBind: {
              width: 600
            },
            formBind: {
              labelWidth: 150
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              tracker_code: [
                {
                  required: true,
                  type: "string",
                  message: "tracker_code cannot be empty",
                  trigger: "blur"
                }
              ],
              tracker_description: [
                {
                  required: true,
                  type: "string",
                  message: "tracker_description cannot be empty",
                  trigger: "blur"
                }
              ],
              tracker_description_cn: [
                {
                  required: true,
                  message: "tracker_description_cn cannot be empty",
                  trigger: "change"
                }
              ],
              status_id: [
                {
                  required: true,
                  type: "number",
                  message: "status cannot be empty",
                  trigger: "change"
                }
              ],
              is_unique: [
                {
                  required: true,
                  type: "string",
                  message: "is_unique cannot be empty",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            { status_id: 24 },
            { tracker_code: 24 },
            { tracker_description: 24 },
            { tracker_description_cn: 24 },
            { is_unique: 24 }
          ],
          fields: [
            {
              name: this.$tz("主状态"),
              key: "status_id",
              component: "Select",
              placeholder: () => this.$tz("主状态"),
              options: [],
              optionsFn: "traceStatus",
              optionsKey: "",
              default: ""
            },
            {
              key: "tracker_code",
              name: () => this.$t("tracker_code"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("tracker_code");
              }
            },
            {
              key: "tracker_description",
              name: () => this.$t("tracker_description"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("tracker_description");
              }
            },
            {
              key: "tracker_description_cn",
              name: () => this.$t("tracker_description_cn"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("tracker_description_cn");
              }
            },
            {
              key: "is_unique",
              name: () => this.$t("orderIsUnique"),
              component: "Radio",
              bind: {
                border: true
              },
              options: statusList,
              default: "YES"
            }
          ]
        }
      },
      header: {
        config: {
          custom: false
        },
        searchs: [
          {
            key: "isUnique",
            placeholder() {
              return this.$t("select") + this.$t("orderIsUnique");
            },
            bind: {
              style: "width:220px;"
            },
            component: "Select",
            options: statusList
          },
          {
            key: "status",
            placeholder() {
              return this.$tz("主状态");
            },
            component: "Select",
            options: [],
            optionsFn: "traceStatus",
            optionsKey: ""
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "addFun",
              id: 171,
              bind: {
                type: "warning",
                icon: "md-add"
              }
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            addFun() {
              this.getModal("add").open(null, function() {
                this.setTitle(this.$t("add"));
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$tz("主状态"),
          key: "status",
          minWidth: 110
        },
        {
          name: () => this.$t("tracker_code"),
          key: "tracker_code",
          align: "left",
          minWidth: 100
        },
        {
          name: this.$t("tracker_description"),
          key: "tracker_description",
          align: "left",
          minWidth: 100
        },
        {
          name: () => this.$t("tracker_description_cn"),
          key: "tracker_description_cn",
          align: "left",
          minWidth: 120
        },
        {
          name: () => this.$t("orderIsUnique"),
          key: "is_unique",
          align: "center",
          width: 100,
          methods: {
            render({ value }) {
              return statusList.find(item => item.value == value).label;
            }
          }
        },

        {
          type: "btns",
          width: 200,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              id: 172,
              bind: {
                type: "success"
              }
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              id: 173,
              bind: {
                type: "error"
              }
            }
          ],

          methods: {
            async updateFun({ row }) {
              let res = await this.handleRequestMethods("getDetails", {
                id: row.id
              });
              this.getModal("add").open(
                {
                  tracker_code: res.payload.tracker_code,
                  tracker_description: res.payload.tracker_description,
                  tracker_description_cn: res.payload.tracker_description_cn,
                  is_unique: res.payload.is_unique,
                  id: row.id
                },
                function() {
                  this.setTitle(this.$t("update"));
                }
              );
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("delete") +
                  '"' +
                  row.tracker_code +
                  '"' +
                  this.$t("tracker_code") +
                  "?",
                onOk: () => {
                  this.handleRequestMethods(
                    "del",
                    {
                      id: row.id
                    },
                    true
                  ).then(res => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
<style type="text/css">
/* @page{
    size: 7cm 8cm;
  } */
</style>
<style lang="scss" scoped></style>
